import React, { useEffect } from "react";
import { motion } from "motion/react";
import { useInView } from "react-intersection-observer";
import { useAnimation } from "motion/react";

const CircleTimeline = () => {
  const { ref, inView, entry } = useInView({});
  const animation = useAnimation();
  useEffect(() => {
    if (inView) {
      animation.start({
        opacity: 1,

        transition: {
          duration: 1,
          ease: "easeInOut",
        },
      });
    }
    if (!inView) {
      animation.start({
        opacity: 0,
        transition: {
          duration: 1,
          ease: "easeInOut",
        },
      });
    }
  }, [inView]);
  
  

  return (
    <motion.div
      ref={ref}
      animate={animation}
      className="absolute w-5 h-5  rounded-full bg-forging-yellow z-10 text-white flex items-center justify-center"
    ></motion.div>
  );
};

export default CircleTimeline;
